export const luhnCheck = (cardNumber: string): boolean => {
    const num = cardNumber.replace(/\D/g, '');

    let odd = true;
    let sum = 0;
    const digits = num.split('').reverse();
    for (const item of digits) {
        let digit = parseInt(item, 10);
        if ((odd = !odd)) {
            digit *= 2;
        }
        if (digit > 9) {
            digit -= 9;
        }
        sum += digit;
    }

    return sum % 10 === 0;
};
